import { etbInt } from '@/lib/money';

interface Props {
    stakeLabel: string;
    prizePool: number;
    cap: number;
    live?: boolean;
}

export function JackpotBar({ stakeLabel, prizePool, cap, live = true }: Props) {
    const pct = cap > 0 ? Math.min(100, (prizePool / cap) * 100) : 0;

    return (
        <div className="w-jackpot">
            <div className="w-jackpot-head">
                <span>
                    {stakeLabel} JACKPOT {etbInt(prizePool)} / {etbInt(cap)}
                </span>
                {live && <span className="w-jackpot-live">LIVE</span>}
            </div>
            <div className="w-jackpot-track">
                <div className="w-jackpot-fill" style={{ width: `${pct}%` }} />
            </div>
        </div>
    );
}
